'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)('tr').each(function () {
  var $this = (0, _jquery2.default)(this),
      td_len = $this.find('td').length;
  if (td_len == 2) $this.addClass('td-two');
  if (td_len == 3) $this.addClass('td-three');
  if (td_len == 4) $this.addClass('td-four');
}); /**
     * Table Script
     * ------------------------------------------------------------------------------
     * A file that contains scripts highly couple code to the Tables
     * 
     * @namespace tables
     */